import styled from 'styled-components'
import { media, colors } from 'styles'
import StyledUserList from 'components/UserList/StyledUserList'

const StyledFindDate = styled.div`
  flex: 1;
  position: relative;

  ${StyledUserList} {
    margin-top: 1rem;
  }

  .search-toggle {
    display: inline-block;
    padding: 1rem 1rem 1rem 0;
    margin-top: -0.5rem;
    font-size: 1.5rem;
    font-weight: 600;
    color: ${colors.textMain};
    cursor: pointer;

    .fa {
      position: relative;
      margin-left: 1.5rem;
      color: ${colors.highlight};
      box-shadow: 0 0 0 0.2rem ${colors.highlight};
      width: 2.5rem;
      line-height: 2.5rem;
      border-radius: 50%;
      text-align: center;
      transform-origin: center;
    }
  }
  form {
    position: absolute;
    z-index: 3; // UserThumb - StatusPanel has 2
    background: ${colors.mainBackground};
    width: 100%;
    top: 4rem;
    bottom: 0;
    transition: bottom 0.5s, opacity 0.5s;
  }
  .basic-filters,
  .advanced-filters {
    opacity: 1;
    transition: 0.5s;
  }
  &.search-open form {
    animation: overflow-hidden 1s; // hide overflow during transition
  }
  &.search-closed {
    .search-toggle .fa {
      transform: rotate(180deg);
    }
    form {
      bottom: 100%;
      opacity: 0.75;
      overflow: hidden;
    }
    .basic-filters,
    .advanced-filters {
      opacity: 0;
      margin: 0;
      padding: 0;
    }
  }
  ${media.mobile`
    &.search-open {
      form {
        height: auto;
        position: static;
      }
      ${StyledUserList} {
        position: absolute;
        opacity: 0;
        pointer-events: none;
        max-height: 0;
        overflow: hidden;
      }
    }
  `}

  @keyframes overflow-hidden {
    from {
      overflow: hidden;
    }
  }
`

export default StyledFindDate
